import { render, staticRenderFns } from "./BooleanPrompt.vue?vue&type=template&id=28725244&scoped=true&"
import script from "./BooleanPrompt.vue?vue&type=script&lang=js&"
export * from "./BooleanPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28725244",
  null
  
)

export default component.exports